import { getDataSecurityApplicationObjects } from '@api';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const getCoreDataSecurityApplicationsObjectsSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityApplicationsObjects',
	receive: true,
	request: true,
	requestHandler: getDataSecurityApplicationObjects,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
